import { LiliTransaction } from '../types/lili-transaction';

export const getTransactionById = (transactions: LiliTransaction[], transactionId: string) => transactions.find((transactionItem: LiliTransaction) => transactionItem.transactionId === transactionId);
